import Blue from "~/core";

new Blue({
	name: 'Video',
	selector: ".video",
	setup(container) {
    const inner = container.querySelector(".video__inner");
		const thumbnail = container.querySelector(".video__thumbnail");
		const video = inner.querySelector("iframe") || inner.querySelector("video");

		if (thumbnail.getAttribute("src") === "" || thumbnail.getAttribute("src") === null) {
			thumbnail.remove();
		} else {
			video.style.visibility = "hidden";
		}

		const playVideo = () => {
			if (!inner.matches(".played")) {
				video.style.visibility = "visible";
				if (video.matches("iframe")) {
					if (!video.getAttribute("src").includes("?")) {
						video.setAttribute("src", video.getAttribute("src") + "?autoplay=1");
					} else {
						video.setAttribute("src", video.getAttribute("src") + "&autoplay=1");
					}
				} else if (video.matches("video")) {
					video.play();
				}
				inner.classList.add("played");
				inner.setAttribute("tabindex", "");
			}
		}
		
		this.$addEvents(thumbnail, "click enter", playVideo);
		this.$addEvents(inner, "click enter", playVideo);
		this.$addEvents(video, "click enter", playVideo);
	}
});